var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('api-loader',{attrs:{"method":"get","url":("v1/sales/egg-orders/" + (encodeURIComponent(_vm.id)))},on:{"loaded":function($event){_vm.order = $event}}},[(_vm.order)?_c('egg-order',{attrs:{"order":_vm.order},on:{"saved":_vm.onOrderSaved}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7455f16c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sales/views/EggOrderView.vue
// module id = null
// module chunks = 